import { safeDefine } from "../../registration/safe-define.js";
import { LiveButtonElement } from "../../ui/live-button/element.js";
//#region src/define/ui/live-button.ts
safeDefine(LiveButtonElement);
//#endregion

//# sourceMappingURL=live-button.js.map